module.exports = __webpack_public_path__ + "img/ni.f6092c86.svg";